// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yw5d","toggle":"styles_toggle__3h-aJ","preview":"styles_preview__2FqLz"};